import { logUsage } from 'owa-analytics';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { isSharePointLink } from 'owa-sharepoint-link-detector';
import { parse as parseUrl } from 'url';
import { isOneDriveConsumerLink } from './isOneDriveConsumerLink';

export function checkSharingLinkUrlDomain(url: string, providerType: AttachmentDataProviderType) {
    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            checkODBLinkDomain(url);
            break;
        case AttachmentDataProviderType.OneDriveConsumer:
            checkODCLinkDomain(url);
            break;
        default:
            throw new Error(`checkSharingLinkUrlDomain do not support ${providerType}`);
    }
}

function checkODBLinkDomain(url: string) {
    if (!isSharePointLink(url)) {
        logUnknownDomain(url);
    }
}

function checkODCLinkDomain(url: string) {
    if (!isOneDriveConsumerLink(url)) {
        logUnknownDomain(url);
    }
}

function logUnknownDomain(url: string) {
    const domain: string = parseUrl(url).hostname;
    logUsage('FileProviderSharingLinkUnknownDomain', { unknownDomain: domain });
}
